const URLSearchParams = (search: string): Record<string, string> =>
  search
    .substring(1)
    .split('&')
    .reduce((params: Record<string, string>, param: string) => {
      const [k, v = ''] = param.split('=');
      return { ...params, [k]: decodeURIComponent(v.replace(/\+/g, ' ')) };
    }, {});

export function delegateLocationAttribute(): string {
  const search = URLSearchParams(location.search);
  const thimble_source = search.utm_source || search.thimble_source;
  const thimble_campaign = search.utm_campaign || search.thimble_campaign;
  const thimble_medium = search.utm_medium || search.thimble_medium;
  const thimble_content = search.utm_content || search.thimble_content;
  const thimble_term = search.utm_term || search.thimble_term;
  const thimble_gclid = search.thimble_gclid;

  return Object.entries({
    thimble_source,
    thimble_campaign,
    thimble_medium,
    thimble_content,
    thimble_term,
    thimble_gclid,
  })
    .filter(([, value]) => value)
    .reduce((str, [key, value]) => `${str}&${key}=${encodeURIComponent(value)}`, '')
    .substring(1);
}
